import update from 'immutability-helper'
import * as ActionTypes from '../../constants/link/MyLInkActionTypes'
import * as SaveStatus from '../../constants/SaveStatus'
import { makeOrderedMyLinks } from './MyLinksStoreHelper'

const initialState = {
	links: [],
	saveStatus: SaveStatus.READY
}

export default (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.RECEIVE_MY_LINK:
			return update(state, {
				links: {
					$set: makeOrderedMyLinks(action.data.links, action.data.ordering)
				}
			})

		case ActionTypes.MOVE_LINK:
			const dragItem = state.links[action.dragIndex]

			return update(state, {
				links: {
					$splice: [
						[action.dragIndex, 1],
						[action.hoverIndex, 0, update(dragItem, {
							isTemporary: {
								$set: action.isTemporary
							}
						})],
					],
				}
			})

		case ActionTypes.DROP_LINK:
			return update(state, {
				links: {
					[action.dragIndex]: {
						isTemporary: {
							$set: false
						}
					}
				},
				saveStatus: {
					$set: SaveStatus.CAN_SUBMIT
				}
			})

		case ActionTypes.CHANGE_SAVE_STATUS:
			return update(state, {
				saveStatus: {
					$set: action.saveStatus
				}
			})

		case ActionTypes.AFTER_SAVE:
			return update(state, {
				saveStatus: {
					$set: SaveStatus.DONE
				}
			})

		case ActionTypes.ADD_LINK:
			return update(state, {
				links: {
					$push: [action.link]
				},
				saveStatus: {
					$set: SaveStatus.DONE
				}
			})

		case ActionTypes.UPDATE_LINK:
			return update(state, {
				links: {
					[state.links.findIndex(item => item.linkId === action.link.linkId)]: {
						$set: action.link
					}
				},
				saveStatus: {
					$set: SaveStatus.DONE
				}
			})

		case ActionTypes.DELETE_LINK:
			return update(state, {
				links: {
					$splice: [
						[state.links.findIndex(item => item.linkId === action.linkId), 1]
					]
				},
				saveStatus: {
					$set: SaveStatus.DONE
				}
			})

		default:
			return state
	}
}
